import { shallowMount } from "@vue/test-utils";
import Mensaje from "@/views/Mensaje";

describe("Mensaje component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Mensaje);
  });

  it("Renders del component Mensaje", () => {
    expect(wrapper).toBeDefined();
  });
});
